import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import { createRef, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import './style.css';

const ref = createRef();

function AppDialogCustom(props) {
  // ---- params ----
  const [dialogShowing, setDialogShowing] = useState(false);
  const [title, setTitle] = useState('');
  const [bodyEl, setBodyEl] = useState();
  const [size, setSize] = useState('');
  const [overflowHidden, setOverflowHidden] = useState(true);
  const [canClickOutsideToDismiss, setCanClickOutsideToDismiss] = useState(true);
  const [centered, setCentered] = useState(false);
  const [dialogClassName, setDialogClassName] = useState('');

  // ---- methods ----
  function handleClose() {
    setDialogShowing(false);
  }

  useEffect(() => {
    ref.current = {
      show: (
        title,
        bodyEl,
        size,
        overflowHidden,
        centered,
        canClickOutsideToDismiss,
        dialogClassName
      ) => {
        setDialogShowing(true);
        setTitle(title);
        setBodyEl(bodyEl);
        setCanClickOutsideToDismiss(canClickOutsideToDismiss ?? true);
        setCentered(centered);
        setSize(size);
        setDialogClassName(dialogClassName ?? '');
        if (overflowHidden !== undefined) {
          setOverflowHidden(overflowHidden);
        }
      },
      hide: () => {
        setDialogShowing(false);
      },
    };

    return () => { };
  }, []);

  useEffect(() => {
    const handlePopState = (event) => {
      // Kiểm tra nếu trạng thái lịch sử không có dialog mở
      // if (!event.state?.isDialogOpen) {
      //   setIsDialogOpen(false);
      // }
      // console.log(event);
      AppCustomDialogHelper.hide();
    };

    // Lắng nghe sự kiện popstate
    window.addEventListener('popstate', handlePopState);

    return () => {
      // Hủy lắng nghe sự kiện khi component bị unmount
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <div>
      <Modal
        className="app-custom-dialog"
        show={dialogShowing}
        onHide={handleClose}
        centered={centered}
        size={size}
        dialogClassName={dialogClassName}
        contentClassName={`rounded-lg ${overflowHidden ? 'overflow-hidden' : ''}`}
        backdrop={canClickOutsideToDismiss ? 'static' : true}
        onEntered={() => {
          Utils.lockedBodyScroll();
        }}
        onExited={() => {
          Utils.unlockedBodyScroll();
        }}
      >
        {!_.isEmpty(title) && (
          <Modal.Header className="p-3">
            <Modal.Title>
              <span style={UIHelper.buildFontStyle('700', '20px', AppColors.gray[800])}>
                {title}
              </span>
            </Modal.Title>
            <div
              className="btn btn-sm btn-icon btn-light btn-hover-secondary cursor-pointer"
              onClick={() => {
                handleClose();
              }}
            >
              <i className="fa-regular fa-times"></i>
            </div>
          </Modal.Header>
        )}

        {/* Body */}
        <Modal.Body className="p-0 overflow-visible">{bodyEl && bodyEl}</Modal.Body>
      </Modal>
    </div>
  );
}

export default AppDialogCustom;
export const AppCustomDialogHelper = {
  show: (
    title,
    bodyEl,
    size = '',
    overflowHidden,
    centered = false,
    canClickOutsideToDismiss = true,
    dialogClassName = ''
  ) => {
    ref.current.show(
      title,
      bodyEl,
      size,
      overflowHidden,
      centered,
      canClickOutsideToDismiss,
      dialogClassName
    );
  },
  hide: () => {
    ref.current.hide();
  },
};
